import {gql} from 'graphql-request';
import {useQuery} from '@tanstack/react-query';
import magentoGraphQLClient from '../services/MagentoApi/graphqlClient';
import getAuthHeaders from '../utils/getAuthHeaders';

const query = gql`
  query getCustomer {
    customer {
      firstname
      lastname
      suffix
      email
      id
      addresses {
        id
        firstname
        lastname
        street
        city
        region {
          region_code
          region
          region_id
        }
        postcode
        country_id
        telephone
        default_shipping
      }
    }
  }
`;

export default function useMagentoCustomer() {
  const {
    refetch: getMagentoCustomer,
    isLoading: isFetchingCustomer,
    data: magentoCustomer,
  } = useQuery({
    queryKey: ['magentoCustomer'],
    queryFn: async () =>
      magentoGraphQLClient.request(query, {}, await getAuthHeaders()),
    enabled: false,
  });

  return {
    getMagentoCustomer,
    magentoCustomer,
    isFetchingCustomer,
  };
}
